import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { Survey } from '../../../../classes';
import { NgModel, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { DateToTimePipe } from '../../../shared';

@Component({
  selector: 'compose-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
  providers:[DateToTimePipe],
})
export class HeaderComponent implements OnInit {
  @Input() survey:Survey;
  @Output() onSave = new EventEmitter();
  @Input() composeFormGroup:FormGroup;
  @ViewChild('open_at_date_model') open_at:NgModel;
  @ViewChild('close_at_date_model') close_at:NgModel;
  minDate:Date;
  maxDate:Date;
  subscriptions:Subscription[] = [];

  constructor(
    private cdRef:ChangeDetectorRef,
    private dateToTimePipe:DateToTimePipe,
  ) { 
    this.maxDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
  }

  ngOnInit() {
    this.addControls();
    if(this.survey.created_at) this.minDate = new Date(this.survey.created_at);
    this.subscriptions.push(this.survey.onContentUpdate.pipe(
      map(()=>this.survey.isChanged), 
      distinctUntilChanged(),
    ).subscribe(()=>{
      this.cdRef.detectChanges()
    }));
    this.subscriptions.push(this.open_at.control.valueChanges.subscribe(()=>this.close_at.control.updateValueAndValidity()));
    this.subscriptions.push(this.composeFormGroup.statusChanges.subscribe(()=>this.cdRef.detectChanges()))
  }
  ngOnDestroy () {
    this.subscriptions.forEach(sub=>sub.unsubscribe());
    this.removeControls();
  }
  private addControls() {
    if (this.composeFormGroup) {
      this.composeFormGroup.setControl('open_at', this.open_at.control);
      this.composeFormGroup.setControl('close_at', this.close_at.control);
    }
  }
  private removeControls() {
    if (this.composeFormGroup) {
      this.composeFormGroup.removeControl('open_at');
      this.composeFormGroup.removeControl('close_at');
     }
  }  

  dateToTime (date:Date) {
    return this.dateToTimePipe.transform(date);
  }
  save () {
    this.onSave.next(null);
  }

}
